import { all, takeEvery, put, call} from 'redux-saga/effects';
import { eventChannel } from "redux-saga";
import actions from './actions';
import omit from 'lodash/omit';
import { rsf, db } from '@iso/lib/firebase/firebase';
import axios from 'axios'
import fileDownload from 'js-file-download'
import {
  convertCollectionsSnapshotToMap,
  deleteDocuments,
  addCollectionAndDocuments,
} from '@iso/lib/firebase/firebase.util';


const COLLECTION_NAME = 'cad_cooperquintas'; // change your collection

function* loadFromFirestore({ payload }) {
  try {
    const ORDER_BY = 'numero_cooperquinta';
    const ORDER = 'asc';

    const collectionRef = db
      .collection(COLLECTION_NAME)
      .orderBy(ORDER_BY, ORDER)

      const snapshots = yield call(rsf.firestore.getCollection, collectionRef);
    // const snapshots = yield call(rsf.firestore.getCollection, COLLECTION_NAME+"/"+payload.email+"/cursos/"+payload.key+"/modulos");
    let data;
    snapshots.forEach(user => {
        data = {
          ...data,
          [user.id]: {...user.data(), key:user.id}
        }
    });
    // let data = yield call(convertCollectionsSnapshotToMap, snapshots);
    
    yield put(actions.loadFromFireStoreSuccess(data));
  } catch (error) {
    console.log(error)
    yield put(actions.loadFromFireStoreError(error));
  }
}

function* loadAnexos({ payload }) {
  try {
    const snapshots = yield call(rsf.firestore.getCollection, COLLECTION_NAME+"/"+payload.keyCooperquinta+"/arquivos/");
    let data;
    let anexos={};
    snapshots.forEach(dt => {
        data = {
          ...data,
          [dt.id]: dt.data()
        }
    });
    anexos[payload.keyCooperquinta]=data;
    yield put(actions.loadAnexosSuccess(anexos));
  } catch (error) {
    console.log(error)
    yield put(actions.loadAnexosError(error));
  }
}


function* storeIntoFirestore({payload}) {
  const { data, actionName, idCooperquinta } = payload;
  const fdata = {...omit(data, ['file'])}
  try {
    // yield call(uploadFile,'private/curso/'+data.email,data.file)

    switch (actionName) {
      case 'delete':
        yield call(
          rsf.firestore.deleteDocument,
          `${COLLECTION_NAME}/${data.key}`);
        break;
      case 'update':
        if(data.file){
          yield call(uploadFiles,'cqc/cooperquintas/'+data.key+"/",data.file,data.key)
          yield put({ type: actions.LOAD_ANEXOS, payload:{keyCooperquinta:data.key}});
        }
        yield call(
          rsf.firestore.setDocument,
          `${COLLECTION_NAME}/${data.key}`,
          {
            ...omit(fdata, ['key']),
          }
        );
        
        break;
      default:
        const key = yield call(rsf.firestore.addDocument, `${COLLECTION_NAME}`, fdata);
        if(data.file){
          yield call(uploadFiles,'cqc/cooperquintas/'+key.id+"/",data.file, key.id)
          yield put({ type: actions.LOAD_ANEXOS, payload:{keyCooperquinta:key.id}});
        }
        break;
    }
    yield put({ type: actions.LOAD_FROM_FIRESTORE, payload:{}});
  } catch (error) {
    console.log(error);
    yield put(actions.saveIntoFireStoreError(error));
  }
}

function* uploadFiles(path, file,keyCooperquinta) {
  if(file.length >0){
    yield all(file.map(f=>{
      return call(uploadFile,path+f.name,f,f.name,keyCooperquinta)
    }))
  }
}

function* uploadFile(path, file,fileName,keyCooperquinta) {
  const task = rsf.storage.uploadFile(path, file);
  const channel = eventChannel(emit => task.on('state_changed', emit));
  yield task
  yield call(updatePathUpload,path,fileName,keyCooperquinta)
}

function* updatePathUpload(path,fileName,keyCooperquinta){
  yield call(
    rsf.firestore.addDocument,
    `${COLLECTION_NAME}/${keyCooperquinta}/arquivos`,
    {
      "caminho":path,
      "fileName":fileName
    }
  );
}


function* downloadFile(data) {
  try{
    const url = yield call(rsf.storage.getDownloadURL, data.payload.caminho);
    
    yield call(handleDownload, url,data.payload.fileName);
  }catch(erro){
    console.log(erro)
  }
  
}

function* handleDownload(url, filename){
  axios.get(url, {
    responseType: 'blob',
  })
  .then((res) => {
    fileDownload(res.data, filename)
  })
}

function* markWatched({ payload }) {
  try {
    const { uid, coopKey } = payload;
    const docId = `${uid}_${coopKey}`;
    yield call(rsf.firestore.setDocument, `cooperquintas_vistas/${docId}`, {
      uid,
      coopKey,
      data: new Date().toISOString(),
    });
  } catch (error) {
    console.log(error);
  }
}

function* loadWatched({ payload }) {
  try {
    const { uid } = payload;
    const collectionRef = db.collection('cooperquintas_vistas').where('uid', '==', uid);
    const snapshots = yield call(rsf.firestore.getCollection, collectionRef);
    let data = {};
    snapshots.forEach(doc => {
      const d = doc.data();
      data[d.coopKey] = true;
    });
    yield put(actions.loadWatchedSuccess(data));
  } catch (error) {
    console.log(error);
  }
}

function* deleteAnexo({payload}) {
  try{
    if(payload.path && payload.keyAnexo){
      yield call(rsf.firestore.deleteDocument, COLLECTION_NAME+"/"+payload.path+payload.keyAnexo);
      let s = payload.path.split("/");
      yield put({type: actions.LOAD_ANEXOS, payload:{email:s[0],key:s[2],keyModulo:s[4]}});
    }
  }catch(erro){
    console.log(erro)
  }
  
  
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_FROM_FIRESTORE, loadFromFirestore),
    takeEvery(actions.SAVE_INTO_FIRESTORE, storeIntoFirestore),
    takeEvery(actions.DOWNLOAD, downloadFile),
    takeEvery(actions.LOAD_ANEXOS, loadAnexos),
    takeEvery(actions.DELETE_ANEXO, deleteAnexo),
    takeEvery(actions.MARK_WATCHED, markWatched),
    takeEvery(actions.LOAD_WATCHED, loadWatched),
  ]);
}
